export const simpleTabsV2Classes = {
  headers: "SimpleTabsV2--headers",
  root: "SimpleTabsV2--root",
  content: "SimpleTabsV2--content",
};
